import Api from 'App/api'

export const getAlerts = Api.get({
  controller: 'alerts',
  action: 'list',
})

export const generateAlerts = Api.get({
  controller: 'alerts',
  action: 'generate',
})

export const dismissSelectedAlerts = Api.post({
  controller: 'alerts',
  action: 'dismiss',
})

export const deleteSelectedAlerts = Api.post({
  controller: 'alerts',
  action: 'delete',
})
